import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertCircle, FiActivity, FiZapOff } = FiIcons;

const ProblemSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">
              Das Risiko des Nicht-Handelns
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Wer ohne saubere System-Architektur beschleunigt, skaliert lediglich seine Probleme.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <SafeIcon icon={FiAlertCircle} className="text-3xl text-red-500 mb-6" />
              <h3 className="text-xl font-bold mb-4">Schnellere Fehler</h3>
              <p className="text-gray-600 leading-relaxed">
                „Unklare Prozesse werden mit KI nur schneller.“ Ohne System-Architektur reproduzieren Sie Ineffizienz in Rekordzeit.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <SafeIcon icon={FiZapOff} className="text-3xl text-red-500 mb-6" />
              <h3 className="text-xl font-bold mb-4">Automatisierte Fehlentscheidungen</h3>
              <p className="text-gray-600 leading-relaxed">
                Eine falsche Entscheidungslogik im System führt zu tausendfachen automatisierten Fehlern im Kundenkontakt.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <SafeIcon icon={FiActivity} className="text-3xl text-red-500 mb-6" />
              <h3 className="text-xl font-bold mb-4">Wachsende technische Schuld</h3>
              <p className="text-gray-600 leading-relaxed">
                Isolierte Tool-Inseln ohne Gesamt-Architektur machen Ihr Unternehmen unflexibel und langfristig teuer in der Wartung.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;